export const UPDATE_FINAL_FORM_VALUES = 'UPDATE_FINAL_FORM_VALUES';
export const CLEAR_FINAL_FORM_VALUES = 'CLEAR_FINAL_FORM_VALUES';
export const updateFinalFormValues = (form, formValues) => ({
    payload: { form, formValues },
    type: UPDATE_FINAL_FORM_VALUES,
});
export const clearFinalFormValues = (form) => ({
    payload: { form },
    type: UPDATE_FINAL_FORM_VALUES,
});
